import { IComponentOptions } from "angular";
import { ProcessNotificationComponentController } from "./controller";

export const vsComponentName = "processNotification";
export const processNotificationComponentOptions: IComponentOptions = {
  controller: ProcessNotificationComponentController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    processActions: "<",
  },
};
